/* globals document, window */
import React, { Fragment } from "react";
import withStyles from "elevate-ui/withStyles";
import { Tools } from "elevate-editor";

import GlobalAlert from "../common/GlobalAlert";

type $Props = {
  alerts: Array<Object>,
  content: Array<Object>,
  previousFormFieldValues: Object,
  siteUser: Object,
};

const Page = ({ alerts, content }: $Props) => {
  return (
    <Fragment>
      <GlobalAlert alerts={alerts} />
      {Tools.renderReact({ content })}
    </Fragment>
  );
};

export default withStyles((theme) => ({
  root: {
    margin: "0 auto",

    "& h1": {
      color: theme.colors.black,
      fontWeight: "700",
      letterSpacing: ".2px",
      fontSize: "32px",
      marginTop: theme.spacing.unit * 4,
      marginBottom: theme.spacing.unit * 0.75,
    },

    "& h2": {
      fontSize: "26px",
      fontWeight: "700",
      marginBottom: theme.spacing.unit * 2,
      marginTop: theme.spacing.unit * 0.75,
    },

    "& h3": {
      fontSize: "21px",
      fontWeight: "700",
      marginBottom: theme.spacing.unit * 2,
      marginTop: theme.spacing.unit * 0.75,
    },

    "& h4": {
      fontSize: "21px",
      fontWeight: "700",
      marginBottom: theme.spacing.unit * 2,
      marginTop: theme.spacing.unit * 0.75,
    },

    "& h5": {
      fontSize: "21px",
      fontWeight: "700",
      marginBottom: theme.spacing.unit * 2,
      marginTop: theme.spacing.unit * 0.75,
    },

    "& h6": {
      fontSize: "21px",
      fontWeight: "700",
      marginBottom: theme.spacing.unit * 2,
      marginTop: theme.spacing.unit * 0.75,
    },

    "& a": {
      color: theme.colors.black,
      textDecoration: "underline",
    },

    "& ol": {
      position: "relative",
      counterReset: "item",
    },

    "& ol li": {
      counterIncrement: "item",
      paddingLeft: theme.spacing.unit * 1.5,

      "&:before": {
        content: 'counter(item) "."',
        position: "absolute",
        left: "0",
        fontWeight: "700",
      },
    },

    "& ul": {
      listStyleType: "disc",
    },

    "& ul li": {
      marginLeft: theme.spacing.unit,
    },

    "& p": {
      marginTop: theme.spacing.unit * 0.25,
      marginBottom: theme.spacing.unit * 0.75,
    },

    "& img": {
      display: "block",
      maxWidth: "100%",
      marginBottom: theme.spacing.unit,
    },

    "& img[alt='This Old House']": {
      width: "120px",
    },

    "& b": {
      fontWeight: "600",
    },
  },
}))(Page);
